import {fileToBlob, handleFetchError, uploadImage} from "./functions.js";
import JSX from "./react.js";

const parentsSelector = '.comment,.leave-comment-body,.add-post-content,.review-form';
const $html = $('html');

export function countWords(el: HTMLElement): number {
    const text = Array.from(el.childNodes).map(ch => (ch as Node).textContent).join('\n'),
        count = text.split(/[ \n]/).filter(e => e.trim()).length;
    $('.comment-words-count b').text(count);
    return count;
}

function insertHtml(textArea: JQuery) {

    try {
        const selection = window.getSelection()!,
            range = selection.getRangeAt(0),
            temp = document.createElement('div'),
            insertion = document.createDocumentFragment();

        temp.innerHTML = '&emsp;';

        while (temp.firstChild) {
            insertion.appendChild(temp.firstChild);
        }
        range.insertNode(insertion);
    } catch (z) {
        try {
            //@ts-ignore
            document.selection!.createRange().pasteHTML('&emsp;');
        } catch (z) {
        }
    }
}

$html.on('mouseup keyup', '.comment-textarea', function (e) {
    const buttons = $(this).parents(parentsSelector).find('.bbcode > div');
    buttons.each(function () {
        let that = $(this);
        that.toggleClass('active', document.queryCommandState(that.data('bb')));
    });
    $(this).find('span:not(.orthography-error)').contents().unwrap();
    $(this).find('*[style]').each(function () {
        $(this).css({color: '', 'background-color': ''});
        if (!$(this).attr('style')) $(this).removeAttr('style');
    })
    countWords(this);
})
    .on('mousedown', '.bbcode > div', async function (e) {
        e.preventDefault()
        const tag: string = $(this).data('bb')!,
            textArea = $(this).parents(parentsSelector).find('.comment-textarea');
        textArea.focus()

        switch (tag) {
            case 'spoiler':
                spoilerText(textArea);
                break;
            case 'quote':
                quoteText(textArea);
                break;
            case 'image':
                insertImage(textArea);
                break;
            case 'hr':
                insertHr(textArea);
                break;
            case 'text-center':
            case 'text-left':
            case 'text-right':
                textFloat(textArea, tag.split('-')[1]! as 'right' | 'center' | 'left')
                break;
            case 'scale':
                textScale(textArea);
                break;
            case 'ident':
                insertHtml(textArea);
                break;
            default:
                document.execCommand(tag, false);
                $(this).toggleClass('active', document.queryCommandState(tag))
        }

    })
    .on('keydown', 'div[contenteditable="true"]', function (event) {
        if (window.getSelection && event.which == 8) {
            const selection = window.getSelection()!;
            if (!selection.isCollapsed || !selection.rangeCount) return;

            const curRange = selection.getRangeAt(selection.rangeCount - 1);
            if (curRange.commonAncestorContainer.nodeType == 3 && curRange.startOffset > 0) return;
            const range = document.createRange();
            if (selection.anchorNode != this) {
                range.selectNodeContents(this);
                range.setEndBefore(selection.anchorNode!);
            } else if (selection.anchorOffset > 0) {
                range.setEnd(this, selection.anchorOffset);
            } else return;

            range?.setStart(this, range.endOffset - 1);
            const previousNode = range?.cloneContents()?.lastChild;
            //@ts-ignore
            if (previousNode?.contentEditable == 'false') {
                range.deleteContents();
                event.preventDefault();
            }
        }
    })
    .on('paste', 'div[contenteditable="true"]', function (event) {
        event.preventDefault();
        let text = (event.originalEvent as ClipboardEvent).clipboardData!.getData('text/html');
        if (!text.length) {
            console.warn("This text is not HTML!")
            text = (event.originalEvent as ClipboardEvent).clipboardData!.getData('text/plain');
            document.execCommand('inserttext', false, text);
        } else {
            text = text.replace(/<!--[\s\S]*?-->/g, "");
            const elements = formatData(text);
            insertTextAtCaret($(this)[0], ...Array.from(elements).reverse());
        }
    });


const allowedTagNames = new Set('P B I U S UL OL SPAN LI STRIKE IMG DIV H2 BLOCKQUOTE HR TABLE TH'.split(' '));

function formatData(textHtml: string): Node[] {
    //TODO: upload images from <img base64/> to server
    const DIV = document.createElement('div');
    DIV.innerHTML = textHtml.replaceAll('<p', '<div').replaceAll('</p>', '</div>');

    function replaceWithOtherTag(element: HTMLElement, tag: 'h2' | 'b' | 'i' | 'u' | 's' = 'h2') {
        if (!['DIV', 'SPAN', 'P'].includes(element.tagName)) {
            const newEl = document.createElement(tag);
            const oldChildren = Array.from(element.childNodes);

            for (const child of oldChildren) newEl.appendChild(child);
            element.appendChild(newEl);
            return element;
        }
        const children = Array.from(element.childNodes);
        const newEl = document.createElement(tag);
        newEl.append(...children);
        element.replaceWith(newEl)
        return newEl;
    }

    function formatElement(element: HTMLElement): any {
        if (!(element instanceof HTMLElement)) {
            if ((element as any) instanceof Text) {
                if ((element as Text).textContent?.startsWith('\t')) {
                    (element as Text).textContent = (element as unknown as Text).textContent?.replaceAll('\t', ' ') ?? ""
                }
                return;
            }
        }

        if (!allowedTagNames.has(element.tagName)) {
            if (['STYLE', 'META', 'TITLE'].includes(element.tagName)) {
                element.remove();
                return;
            } else if (element.tagName === 'FONT') {
                const children = Array.from(element.childNodes);
                if (parseInt(element.style.fontSize) > 15) {
                    element = replaceWithOtherTag(element);
                } else {
                    element.replaceWith(...children);
                    for (const el of children) formatElement(el! as any);
                    return;
                }
            } else {
                const childs = Array.from(element.childNodes);
                element.replaceWith(...childs);
                for (const el of childs) formatElement(el! as any);
                return;
            }
        } else if (element.tagName === 'DIV' && element.parentElement?.tagName === 'LI') {
            const children = Array.from(element.childNodes);
            element.replaceWith(...children);
            for (const el of children) formatElement(el! as any);
            return;
        } else if (element.tagName === 'DIV' && !element.innerHTML.trim().length) {
            element.remove();
            return;
        } else if (element.tagName === 'IMG') {
            const src = element.getAttribute('src');
            if (src?.startsWith('data:image/')) {

                fetch(src)
                    .then(res => res.blob())
                    .then(uploadImage)
                    .then(url => element.setAttribute('src', url))
                    .then(console.log)
                    .catch(e => {
                        handleFetchError(e);
                    })

            } else if (src?.startsWith('//') || src?.startsWith('http://') || src?.startsWith('https://')) {
                //pass, everything is OK
            } else console.warn('Image src is not base64', src?.substring(0, 1000));
        } else if (element.tagName === 'DIV' && element.children.length === 1 && ['DIV', 'BR', 'OL', 'UL'].includes(element.children[0].tagName)) {
            const children = Array.from(element.childNodes);
            element.replaceWith(...children);
            for (const child of children) formatElement(child as HTMLElement);
        }

        const currentStyle = Object.fromEntries(
            (element.getAttribute('style') ?? '')!.split(';').map(e => e.split(':', 2).map(e => e.trim()))
        );
        if (element.hasAttribute('align')) {
            const align = element.getAttribute('align')!;
            if (align) currentStyle['text-align'] = align;
        }
        for (const key in currentStyle) {
            if (key === 'text-align') continue;
            else if (key === 'font-size') {
                if (parseInt(currentStyle[key]) > 15 && element.tagName !== 'H2') {
                    element = replaceWithOtherTag(element);
                }
            } else if (key === 'font-weight') {
                if (parseInt(currentStyle[key]) >= 500) {
                    element = replaceWithOtherTag(element, 'b');
                }
            } else if (key === 'font-style') {
                if (currentStyle[key] === 'italic') {
                    element = replaceWithOtherTag(element, 'i');
                }
            } else if (key === 'text-decoration') {
                if (currentStyle[key] === 'line-through') {
                    element = replaceWithOtherTag(element, 's');
                } else if (currentStyle[key] === 'underline') {
                    element = replaceWithOtherTag(element, 'u');
                }
            }
            delete currentStyle[key];
        }
        if (Object.keys(currentStyle).length === 0) element.removeAttribute('style');
        else element.setAttribute('style', Object.entries(currentStyle).map(e => e.join(':')).join(';'));
        for (const name of element.getAttributeNames()) {
            if (!['style', 'src', 'alt', 'abbr', 'summary'].includes(name)) element.removeAttribute(name);
        }
        for (const el of Array.from(element.childNodes)) {
            formatElement(el as HTMLElement)
        }
    }

    while (DIV.childNodes.length === 1 && DIV.firstChild?.nodeName === 'DIV') {
        DIV.innerHTML = (DIV.firstChild! as HTMLElement).innerHTML;
    }
    for (let el of Array.from(DIV.childNodes)) {
        if (!(el instanceof HTMLElement) || el.tagName !== 'DIV') {
            const newEl = document.createElement('div');
            if (el instanceof HTMLElement) newEl.innerHTML = el.outerHTML;
            else newEl.innerText = el.textContent!;
            el.replaceWith(newEl);
            el = newEl;
        }
        formatElement(el! as HTMLElement)
    }
    let el;
    //Join 2 OL's into one
    while ((el = DIV.querySelector('ol:has( + ol li)'))) {
        for (const child of Array.from(el.nextElementSibling!.childNodes)) {
            el.appendChild(child);
        }
        el.nextElementSibling!.remove();
    }
    while ((el = DIV.querySelector('h2:has(+h2)'))) {
        for (const child of Array.from(el.nextElementSibling!.childNodes)) {
            el!.appendChild(child);
        }
        el!.nextElementSibling!.remove();
    }
    return DIV.childNodes as unknown as Node[];
}

function insertTextAtCaret(parent: HTMLElement, ...text: Node[]) {
    if (window.getSelection) {
        let selection = window.getSelection();
        if (selection?.rangeCount ?? 0 > 0) {
            let range = selection!.getRangeAt(0);
            if (parent.contains(range.commonAncestorContainer)) {
                range.deleteContents();
            }
        }
    }

    console.log(Array.from(text));
    document.activeElement?.append(...Array.from(text).reverse());
    // const emptyDiv = document.createElement('div');
    // emptyDiv.innerHTML = '&emsp;';
    // document.activeElement?.appendChild(emptyDiv);
    let range, selection;
    if (document.createRange && document.activeElement)//Firefox, Chrome, Opera, Safari, IE 9+
    {
        range = document.createRange();//Create a range (a range is a like the selection but invisible)
        range.selectNodeContents(document.activeElement);//Select the entire contents of the element with the range
        range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
        selection = window.getSelection();//get the selection object (allows you to change selection)
        selection?.removeAllRanges();//remove any selections already made
        selection?.addRange(range);//make the range you have just created the visible selection
    }
}

function insertHr(textArea: JQuery) {
    const selObj = window.getSelection()! as Selection,
        el = $('<hr/>');
    if (selObj?.rangeCount ?? 0 > 0) {
        let node = selObj.focusNode;
        while (!$(node!.parentElement!).hasClass('comment-textarea')) node = node!.parentElement;
        el.insertAfter(node!);
        // range.insertNode(el[0]);
    } else textArea.append(el);

}

function insertImage(textArea: JQuery) {
    const $input: JQuery<HTMLInputElement> = $('<input type="file" hidden style="display: none" accept="image/jpeg,image/png">').appendTo('body') as JQuery<HTMLInputElement>;
    $input[0].onerror
    $input.trigger('click');
    $input.on('input', async ev => {
        //@ts-ignore
        const buffer: File = ev.originalEvent!.target!.files![0]!;//.arrayBuffer() as ArrayBuffer;
        try {
            const file = await fileToBlob(buffer);

            const url = await uploadImage(file),
                selObj = window.getSelection()! as Selection;
            let text = `<img src="${url}" alt="Image" style="margin: 0 auto">`
            if (selObj?.rangeCount ?? 0 > 0) {
                let range = selObj!.getRangeAt(0);
                range.insertNode($(text)[0]);
            } else textArea.append($(text));
        } catch (e) {
            handleFetchError(e);
        }
        // if(buffer){
        //     let text = await arrayBufferToBase64(buffer),
        //         selObj = window.getSelection()! as Selection;
        //     text = `<img src="data:image/jpeg;base64,${text}" alt="Image">`
        //     if (selObj?.rangeCount??0 > 0) {
        //         let range = selObj!.getRangeAt(0);
        //         range.insertNode($(text)[0])
        //     }
        //     else textArea.append($(text)); // document.execCommand('inserttext', false, text);
        //
        // }
        $input.remove();
    }).on('error', () => $input.remove());
}

function quoteText(textArea: JQuery) {
    let text = '<blockquote><p>Quote</p></blockquote><div>...</div>',
        selObj = window.getSelection()! as Selection;
    if (selObj?.rangeCount ?? 0 > 0) {
        let range = selObj!.getRangeAt(0);
        if ($(range.commonAncestorContainer).closest(textArea).length > 0) {
            text = ' <blockquote><p>' + (selObj.toString().replace('\n', '<br>') || 'Quote') + '</p></blockquote>'
        }
        document.execCommand('delete', false)
        range.insertNode($(document.createElement('div')).html('<br>')[0]);
        range.insertNode($(text)[0]);
    } else textArea.append($(text)); // document.execCommand('inserttext', false, text);
}

function spoilerText(textArea: JQuery) {
    let text = ' [спойлер="Спойлер!"] [/спойлер] ',
        selObj = window.getSelection();
    if (selObj?.rangeCount ?? 0 > 0) {
        let range = selObj!.getRangeAt(0);
        if ($(range.commonAncestorContainer).closest(textArea).length > 0) {
            text = ' [спойлер="Спойлер!"] ' + selObj!.toString() + ' [/спойлер] '
        }
    }
    document.execCommand('inserttext', false, text);
}

function textFloat(textArea: JQuery, float: 'right' | 'center' | 'left') {
    const selObj = window.getSelection()! as Selection;
    if (selObj?.rangeCount ?? 0 > 0) {
        const nodes = getRangeSelectedNodes(selObj.getRangeAt(0)!);
        for (let node of nodes) {
            if (node.parentElement!.classList.contains('comment-textarea')) {
                replaceTextNodeWith(`<div style="text-align: ${float}">`, node!, '</div>');
                continue;
            }
            while (node instanceof Text || ['U', 'UNDERLINE', 'B', 'BOLD', 'S', 'STRIKE', 'I', 'ITALIC', 'BR'].includes((node as HTMLElement).tagName))
                node = node.parentNode!;
            if ($(node!).css('text-align') !== 'start')
                $(node).css('text-align', float)
            else if (!replaceTextNodeWith(`<div style="text-align: ${float}">`, node!, '</div>'))
                $(node!).css('text-align', float)
        }
        // selObj.selectAllChildren()
        // const node = selObj.focusNode!.nodeName == '#text'? selObj.focusNode!.parentElement : selObj.focusNode

    } else textArea.append($('<div style="text-align: center">Center</div>')); // document.execCommand('inserttext', false, text);
}

function replaceTextNodeWith(before: string, node: Node, after: string) {
    if (node instanceof Text) {
        const newNode = $(before + node.textContent + after);
        node.parentNode!.insertBefore(newNode[0]!, node);
        node.parentNode!.removeChild(node);
        return true;
    } else return false;
}

function textScale(textArea: JQuery) {
    const range = window.getSelection()?.getRangeAt(0);
    if (!range) return;
    const nodes = getRangeSelectedNodes(range);
    if (nodes.some(e => e.parentElement!.tagName === 'H2'))
        document.execCommand('formatBlock', false, 'div');
    else
        document.execCommand('formatBlock', false, '<h2>');
}


function nextNode(node: Node) {
    if (node.hasChildNodes()) {
        return node.firstChild;
    } else {
        while (node && !node.nextSibling) {
            node = node.parentNode!;
        }
        if (!node) {
            return null;
        }
        return node.nextSibling;
    }
}

function getRangeSelectedNodes(range: Range) {
    var node = range.startContainer;
    var endNode = range.endContainer;

    // Special case for a range that is contained within a single node
    if (node == endNode) {
        return [node];
    }

    // Iterate nodes until we hit the end container
    var rangeNodes = [];
    while (node && node != endNode) {
        rangeNodes.push(node = nextNode(node)!);
    }
    node = range.startContainer;
    while (node && node != range.commonAncestorContainer) {
        rangeNodes.unshift(node);
        node = node.parentNode!;
    }

    return rangeNodes;
}

export function onLoad() {
    $('.comment-textarea').each(function () {
        countWords(this);
    })
}


